import "./ChallengeCard.css";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import React, { useRef, useEffect, useState } from "react";
import moment from "moment";
import { Button, ToggleButton, ToggleButtonGroup } from "react-bootstrap";
import convertCompletionToToggle from "../utils/convertCompletionsToToggle";
import Comment from "./Comment";
import getTimeDifferent from "../utils/timeDifference";
import { FaCheck, FaTimes } from "react-icons/fa";
import "../pages/boxes.css";
import "../components/sections.css";
import InviteModal from "./InviteModalComponent";
import { Link } from "react-router-dom";
import axiosInstance from "../utils/axiosInstance";
import StatusButton from "./StatusButton";
import { ToastContainer, toast } from "react-toastify";
import getMotivationalMessage from '../utils/motivation';


function MyChallengesCard({
  title,
  description,
  startDay,
  organizer,
  participants,
  spectators = [],
  records,
  challenge_oid,
  currentUser,
  handleMyChallengesArray,
  comments,
  icon,
  onRecreate,
}) {
  // Get index of current user in the completions array of the records array
  const userIndex = records?.[0]?.completions?.findIndex(
    (item) => item.username === currentUser
  ) ?? -1;
  const isSpectator = spectators.includes(currentUser);

  const momentStartDate = moment(startDay);
  const momentEndDate = momentStartDate.clone().add(21, 'days');
  let formattedStartDate = momentStartDate.format("MMMM D, YYYY");
  const currentDayNumber = moment().diff(momentStartDate, "days") + 1;

  let currentDateFmtStr = moment(startDay)
    .add(currentDayNumber - 1, "day")
    .format("MMMM D, YYYY");

  const iconMap = new Map();
  iconMap.set("TrophyA", "/trophies.jpg");
  iconMap.set("TrophyB", "/cartoonTrophy.jpg");
  iconMap.set("BooksA", "/books.jpg");
  iconMap.set("TrophyC", "/gym.jpg");

  const thumbnail = process.env.PUBLIC_URL + '/images' + iconMap.get(icon);
  const [toggleValue, setToggleValue] = useState([]);
  const [isEditing2, setIsEditing2] = useState(false); // [false, false, false, false]
  const [recordsData, setRecordsData] = useState(records);
  const [showEditModal, setShowEditModal] = useState(false);
  const [comment, setComment] = useState("");
  const [commentSection, setCommentSection] = useState(comments);
  const commentContainerRef = useRef(null);
  const [showChallengeBoard, setShowChallengeBoard] = useState(false);
  const [selectedDate, setSelectedDate] = useState(
    currentDayNumber <= 21 && currentDayNumber > 0
      ? currentDateFmtStr
      : formattedStartDate
  );
  const [dayNumber, setDayNumber] = useState(
    currentDayNumber <= 21 && currentDayNumber > 0 ? currentDayNumber : 1
  );
  const [cellColors, setCellColors] = useState(Array(22).fill("white"));
  const [showInviteModal, setShowInviteModal] = useState(false);

  // Generate an array of numbers from 1 to 21
  const numbers = Array.from({ length: 21 }, (_, index) => index + 1);

  // Create a 2D array to represent the 3x7 table
  const tableData = Array.from({ length: 3 }, (_, rowIndex) =>
    numbers.slice(rowIndex * 7, (rowIndex + 1) * 7)
  );

  const handleSquareDayClick = (number) => {
    const updatedColor = Array(22).fill("white");
    updatedColor[number] = "#29ADD9";

    setCellColors(updatedColor);

    setDayNumber(number);
    let value = moment(startDay)
      .add(number - 1, "day")
      .format("MMMM D, YYYY");
    setSelectedDate(value);
  };

  useEffect(() => {
    if (!isSpectator && userIndex >= 0) {
      const completionStatusToggleValues = convertCompletionToToggle(
        records,
        userIndex
      );
      setToggleValue(completionStatusToggleValues);
    }
  }, [isSpectator, records, userIndex]);

  useEffect(() => {
    // Fill current day box with light blue background color
    let defaultSelectedCell = [...cellColors];
    defaultSelectedCell[dayNumber] = "lightblue";
    setCellColors(defaultSelectedCell);

    if (commentContainerRef.current) {
      commentContainerRef.current.scrollTop =
        commentContainerRef.current.scrollHeight;
    }
  }, [commentSection]);

  const updateChallengeRecord = (challengeOID, day, activity, isComplete) => {
    let dataBody = {
      challenge_oid: challengeOID,
      day: day,
      activity: activity,
      is_complete: isComplete,
    };

    if (dataBody.is_complete === null) {
      delete dataBody.is_complete;
    }

    if (dataBody.activity === null) {
      delete dataBody.activity;
    }
    // Must add header for authentication
    axiosInstance
      .put("/challenges/challenge/record", dataBody)
      .then((response) => {
        if (isComplete === true && day !== 21) {
        const message = getMotivationalMessage(currentUser)
        toast.success(message, {
          position: 'top-center', 
          limit: 1, 
        });}

        if (isComplete === true && day === 21) {
          toast.success('Day 21 complete! Thank you for choosing to become a better version of yourself!', {
            position: 'top-center', 
            limit: 1, 
          })
        }
      
      })
      .catch((error) => {});
  };

  const handleEditClick = (index) => {
    setIsEditing2(true);
  };

  const handleInputDeselection = (dayIndex) => {
    setIsEditing2(false);

    const activity = records[dayIndex].completions[userIndex].activity;
    updateChallengeRecord(challenge_oid, dayNumber, activity, null);
  };

  const handleChangeInput2 = (e, index) => {
    const newInput = e.target.value;
    const data = [...recordsData];
    data[index].completions[userIndex].activity = newInput;
    setRecordsData(data);
  };

  const convertToggleToRecords = (value, index) => {
    const newRecords = [...recordsData];
    if (value === 1) newRecords[index].completions[userIndex].done = true;
    else newRecords[index].completions[userIndex].done = false;

    setRecordsData(newRecords);
  };

  const handleToggle = (value, index, day, challenge_id) => {
    // Handles toggle between the "Complete" and "Incomplete" buttons
    convertToggleToRecords(value, index);

    // Update completion status data on server

    const completionStatus = value === 1 ? true : false;
    updateChallengeRecord(challenge_id, day, null, completionStatus);

    setToggleValue((previousValues) => {
      const newValues = [...previousValues];
      newValues[index] = value;

      return newValues;
    });
  };

  const handleDelete = () => {
    axiosInstance
      .delete(`/challenges/challenge/${challenge_oid}`)
      .then((response) => {
        handleMyChallengesArray(challenge_oid);
      })
      .catch((error) => {});
  };

  const handleTextAreaChange = (event) => {
    setComment(event.target.value);
  };

  const addComment = () => {
    if (comment === "") return;
    axiosInstance
      .post(
        "/challenges/comments",
        { comment: `${comment}`, challenge_oid: `${challenge_oid}` },
      )
      .then((response) => {
        setCommentSection([
          ...commentSection,
          { author: currentUser, text: comment },
        ]);
        setComment("");
      })
      .catch((error) => {});
  };

  return (
    <div className="challenge-card">
      <img src={thumbnail} alt="Challenge Icon" className="thumbnail" />
      <div className="content">
        <h3 className="title">{title}</h3>
        <p className="description">{description}</p>

        <div className="start-day-section">
          <span className="start-day-label">Start Day:</span>
          <span className="start-day">
            {momentStartDate.format("MMMM D, YYYY")}
          </span>
        </div>
        <button
          className="open-button"
          onClick={() => {
            setShowChallengeBoard(true);
          }}
        >
          Open
        </button>
        {isSpectator ? <span style={{ marginLeft: "10px" }}>Watching</span> : null}
        {currentUser === organizer ? (
          <button
            className="edit-button"
            onClick={() => setShowEditModal(true)}
          >
            Edit
          </button>
        ) : (
          ""
        )}
        <button
          className="invite-button"
          onClick={() => {
            setShowInviteModal(true);
          }}
        >
          Invite
        </button>
        <button
          className="open-button recreate-button"
          onClick={onRecreate}
        >
          Recreate
        </button>
        <StatusButton startDate={momentStartDate} endDate={momentEndDate}></StatusButton>
      </div>

      <InviteModal
        show={showInviteModal}
        onHide={() => {
          setShowInviteModal(false);
        }}
        challenge_oid={challenge_oid}
      />

      <Modal
        size="xl"
        show={showChallengeBoard}
        onHide={() => setShowChallengeBoard(false)}
        style={{ backgroundColor: "lightblue" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <ToastContainer></ToastContainer>
          <div className="main-container">
            <div className="info-container">
              <table
                style={{
                  borderCollapse: "separate",
                  borderSpacing: "13px",
                  margin: "2%",
                }}
              >
                <tbody>
                  {tableData.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      {row.map((number, columnIndex) => (
                        <td
                          key={number}
                          style={{
                            backgroundColor: cellColors[number],
                          }}
                          className="boxed-days"
                          onClick={() =>
                            handleSquareDayClick(
                              tableData[rowIndex][columnIndex]
                            )
                          }
                        >
                          {number}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <div
                style={{
                  // marginLeft: "35px",
                  marginLeft: "2%",
                  border: "thick double",
                  //width: "385px",
                  width: "95%",
                  backgroundColor: "#ffffff",
                }}
              >
                <table className="challenge-details-table">
                  <thead style={{ textAlign: "center" }}>
                    <tr>
                      <th>Challenge Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style={{ borderBottom: "1px solid #ddd" }}>
                      <td style={{ textAlign: "center" }}>Organizer</td>
                      <td style={{ textAlign: "center" }}>
                        <Link to={`/user/${organizer}`}>{organizer}</Link>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "center" }}>Day</td>
                      <td style={{ textAlign: "center" }}>{dayNumber}</td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "center" }}>Selected Date</td>
                      <td style={{ textAlign: "center" }}>{selectedDate}</td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "center" }}>
                        {isSpectator ? "Access" : "Activity"}
                      </td>

                      <td onClick={() => !isSpectator && handleEditClick(dayNumber - 1)}>
                        {" "}
                        {isSpectator ? (
                          <span>Spectator — progress is read-only</span>
                        ) : isEditing2 ? (
                          <input
                            autoFocus
                            style={{ width: "100%" }}
                            type="text"
                            value={
                              recordsData[dayNumber - 1]?.completions[userIndex]
                                ?.activity
                            }
                            onBlur={() => handleInputDeselection(dayNumber - 1)}
                            onChange={(e) =>
                              handleChangeInput2(e, dayNumber - 1)
                            }
                          />
                        ) : (
                          <span>
                            {
                              recordsData[dayNumber - 1]?.completions[userIndex]
                                ?.activity
                            }
                          </span>
                        )}
                      </td>
                    </tr>

                    {!isSpectator && <tr>
                      <td>Completion Status</td>
                      <td>
                        <center>
                          <ToggleButtonGroup
                            name="toggle-group"
                            type="radio"
                            value={toggleValue[dayNumber - 1]}
                          >
                            <ToggleButton
                              value={1}
                              variant={
                                toggleValue[dayNumber - 1] === 1
                                  ? "success"
                                  : "light"
                              }
                              onClick={() =>
                                handleToggle(
                                  1,
                                  dayNumber - 1,
                                  dayNumber,
                                  challenge_oid
                                )
                              }
                            >
                              Complete
                            </ToggleButton>

                            <ToggleButton
                              value={2}
                              variant={
                                toggleValue[dayNumber - 1] === 2
                                  ? "danger"
                                  : "light"
                              }
                              onClick={() =>
                                handleToggle(
                                  2,
                                  dayNumber - 1,
                                  dayNumber,
                                  challenge_oid
                                )
                              }
                            >
                              Incomplete
                            </ToggleButton>
                          </ToggleButtonGroup>
                        </center>
                      </td>
                    </tr>}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="social-container">
              <Modal.Body style={{ maxHeight: "300px", overflowY: "auto" }}>
                <table style={{ width: "100%" }}>
                  <thead>
                    <tr>
                      <th>Day</th>
                      <th>{organizer}</th>
                      {participants.map((participant) => (
                        <th>{participant}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {recordsData.map((records) => {
                      return (
                        <tr style={{ borderBottom: "1px solid #ddd" }}>
                          <td>{records.day}</td>
                          {records.completions.map((completion) => (
                            <td>
                              {completion?.done === true ? (
                                <>
                                  <FaCheck
                                    className="checkmark"
                                    style={{ color: "green" }}
                                  />{" "}
                                  <span style={{ fontSize: "0.65em" }}>
                                    {completion.dt_complete}
                                  </span>
                                </>
                              ) : (
                                <FaTimes style={{ color: "red" }} />
                              )}
                            </td>
                          ))}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </Modal.Body>
              <hr></hr>
              <Modal.Body>
                <h5>Conversation</h5>
                <h6>({commentSection?.length || 0} Comments)</h6>
                <div
                  ref={commentContainerRef}
                  style={{
                    maxHeight: "150px",
                    overflowY: "auto",
                    backgroundColor: "#FFFFCC",
                    borderRadius: "10px",
                  }}
                >
                  {commentSection?.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp)).map((comment) => {
                    return (
                      <Comment
                        username={comment.author}
                        timestamp={getTimeDifferent(comment.timestamp)}
                        text={comment.text}
                      />
                    );
                  })}
                </div>

                <div style={{ marginTop: "10px" }}>
                  <textarea
                    maxLength="200"
                    placeholder="Say something!"
                    value={comment}
                    onChange={handleTextAreaChange}
                    style={{
                      width: "100%",
                      resize: "none",
                      borderRadius: "10px",
                    }}
                  ></textarea>
                  <Button
                    variant="outline-secondary"
                    onClick={() => addComment()}
                  >
                    Send
                  </Button>
                </div>
              </Modal.Body>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
        <Modal.Body>
          <Modal.Title>Edit Challenge</Modal.Title>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Title</Form.Label>
              <Form.Control type="input" value={title} disabled></Form.Control>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control
                type="input"
                value={description}
                disabled
              ></Form.Control>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Form.Text className="text-muted">
            Delete will remove the challenge & all its data.
          </Form.Text>
          {/* TODO Add an are you sure pop-up before deletion and then remove the disabled option below*/}
          <Button
            variant="danger"
            onClick={() => {
              handleDelete();
            }}
          >
            Delete
          </Button>
          <Button variant="success">Save</Button>
        </Modal.Footer>
      </Modal>
      
    </div>
  );
}

export default MyChallengesCard;
